import owlCarousel from "owl.carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { ContactForm } from "./ContactForm";
import "./owl-carousel";
import "./burger-menu";

require("./jquery-template");
require("./lwsreviews-feed");

require("jquery-custom-select");
require("@fancyapps/fancybox");
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
ContactForm.init();

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000,
          function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }
    }
  });
//
//Filtres ajax
// FIltres e-shop
$(".loading").hide();
window.applyFilters = function () {
  var filter = $("#filter");
  let data = filter.serialize();

  $.ajax({
    url: filter.attr("action"),
    data: filter.serialize() + "&orderby=" + $("select.orderby").val(), // form data
    type: filter.attr("method"), // POST
    beforeSend: function (xhr) {
      // filter.find('button').text('Processing...'); // changing the button label
      $(".loading").css("display", "inline-block");
      $("ul.products").css("opacity", "0.3");
      //    var nbitems = 0;
    },
    success: function (data) {
      // filter.find('button').text('Filtrer'); // changing the button label back
      let txtarticle = "";

      $("#response").html(data); // insert data
      var nbitems = $(".product").length;

      if (nbitems <= 1) {
        txtarticle = " article";
      } else {
        txtarticle = " articles";
      }
      $(".woocommerce-result-count").text(nbitems + txtarticle);
      $(".loading").hide();
      $("ul.products").css("opacity", "1");
    },
  });
  return false;
};

$('#filter input[type="checkbox"]').click(function () {
  applyFilters();
});

//

$(".filters_toggle").on("click", function (e) {
  e.preventDefault();
  $(this).toggleClass("open");
  $(".sidebar_filtres").toggleClass("open");
});

// Tri a droite page produits
var $select = $("select.orderby");

$select.customSelect({
  hideCallback: function () {
    applyFilters();
  },
});
var $variation_wrap = $(".variation-wrap");
// $variation_wrap.customSelect();
var timeout;

$(".woocommerce").on("change", "input.qty", function () {
  if (timeout !== undefined) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(function () {
    $("[name='update_cart']").removeAttr("disabled");
    $("[name='update_cart']").trigger("click");
  }, 500); // 1 second delay, half a second (500) seems comfortable too
});

//
// cacher résumé du panier
$(".widget_shopping_cart").append('<a class="closewidget">Fermer ></a>');
$(document).mouseup(function (e) {
  var container = $(".widget_shopping_cart");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.removeClass("showme");
  }
});
$(".closewidget").on("click", function (e) {
  e.preventDefault();
  $(".widget_shopping_cart").removeClass("showme");
});
// plus minus quantity
$(".woocommerce").on("click", ".button_plus", function (e) {
  e.preventDefault();
  // if ($(this).prev().val() < 3) {
  $(this)
    .prev()
    .val(+$(this).prev().val() + 1);
  $(this).prev().trigger("change");
  // }
});
$(".woocommerce").on("click", ".button_minus", function (e) {
  e.preventDefault();
  if ($(this).next().val() > 1) {
    if ($(this).next().val() > 1)
      $(this)
        .next()
        .val(+$(this).next().val() - 1);
    $(this).next().trigger("change");
  }
});
